import { useParams, Navigate } from "react-router-dom";
import { SectionsPage } from "@/components/SectionsPage";
import { resourceCategories } from "@/data/resources";

export default function ResourceCategory() {
  const { slug } = useParams();
  const r = resourceCategories.find((x) => x.slug === slug);
  if (!r) return <Navigate to="/resources" replace />;

  return (
    <SectionsPage
      seoTitle={r.seoTitle}
      seoDescription={r.seoDescription}
      path={`/resources/${r.slug}`}
      back={{ to: "/resources", label: "All resources" }}
      eyebrow="Resources"
      title={r.title}
      subtitle={r.intro}
      note="New content is on the way — check back soon, or contact us for specific guidance in the meantime."
      cta={{ label: "Ask us a question", to: "/contact" }}
      testid={`resource-${r.slug}`}
    />
  );
}
